import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Button, Container, DGSelectEdit, EditableDataGrid, GridItem, GridRow, MenuItem, SearchField, Spacer, Typography } from '@emburse/embark-core';
import DataGridLoading from '../../../../../views/QuickSetup/components/DataGridLoading';
import { $t, useTranslation } from '../../../../../hooks/useTranslation';
function EmployeeMappingTable({ tableData, empGLDs, selectedUsers, setSelectedUsers, onSetShowDrawer, rowChangeHandler, loading }) {
    useTranslation();
    const generateGLDItems = (index) => {
        const empGLD = empGLDs[index];
        const menuItems = [];
        if (empGLD.Rows.length === 0) {
            menuItems.push(_jsx(MenuItem, { value: { Name: 'No values uploaded' }, disabled: "true", children: "No values uploaded" }, "0"));
        }
        else {
            menuItems.push(_jsx(MenuItem, { value: 0 }, "-1"));
            menuItems.push(empGLD.Rows.map((item) => (_jsx(MenuItem, { value: item.PK, children: item.Name }, item.PK))));
        }
        return menuItems;
    };
    const dynamicColumns = () => {
        const columns = [];
        for (let i = 0; i < 5; i += 1) {
            const empGLD = empGLDs[i];
            const columnName = `GLD${i + 1}PK`;
            if (empGLD.Label.length > 0) {
                columns.push({
                    field: columnName,
                    headerName: empGLD.Label,
                    flex: 4,
                    editable: true,
                    valueFormatter: (params) => empGLD.Rows.filter((item) => parseInt(params.value, 10) === item.PK)[0]
                        ?.Name || '',
                    renderEditCell: (params) => (_jsx(DGSelectEdit, { params: params, componentProps: {
                            id: `Assigned${columnName}`,
                            defaultValue: params.row[columnName],
                            children: generateGLDItems(i)
                        } }))
                });
            }
        }
        return columns;
    };
    const columns = dynamicColumns();
    const [search, setSearch] = useState('');
    const filterdTableData = () => tableData.filter((item) => {
        const regex = new RegExp(search, 'gi');
        return item?.Name.search(regex) >= 0;
    });
    const saveRow = async (id, row) => {
        rowChangeHandler(row);
        return { success: true };
    };
    return (_jsxs(Container, { disableGutters: true, children: [_jsx(GridRow, { justifyContent: "space-between", children: _jsx(GridItem, { children: _jsx(Typography, { variant: "h5", children: $t('Users') }) }) }), _jsx(Spacer, { size: 10 }), _jsxs(GridRow, { justifyContent: "space-between", children: [_jsx(GridItem, { children: _jsx(SearchField, { id: "SearchUsers", label: $t('Search'), doSearchOnChange: true, searchAction: (val) => setSearch(val) }) }), _jsx(GridItem, { children: _jsx(Button, { variant: "outlined", disabled: selectedUsers.length < 2, onClick: () => onSetShowDrawer(true), children: $t('Bulk Edit') }) })] }), _jsx(Spacer, { size: 35 }), _jsx(EditableDataGrid, { allowSelection: true, autoHeight: true, pageSizeOptions: [25], rows: filterdTableData(), hideOnSaveSuccessSnackbar: true, onRowSelectionModelChange: (users) => setSelectedUsers(users), onSave: saveRow, localeText: { noRowsLabel: '' }, columns: [
                    {
                        field: 'Name',
                        headerName: $t('User name'),
                        flex: 4,
                        editable: false,
                        type: 'string'
                    },
                    ...columns
                ] }), loading && _jsx(DataGridLoading, {})] }));
}
export default EmployeeMappingTable;
